import { ReactElement } from 'react';
import { Tooltip as MuiTooltip, Typography, SxProps } from '@mui/material';

export type Props = {
  children: ReactElement<any, any>;
  title: string | React.ReactNode;
  isOpen?: boolean;
};

const tooltipSx: SxProps = {
  backgroundColor: 'black',
  color: 'white',
  borderRadius: 8,
  padding: 8,
  fontWeight: 'bold'
};

const arrowSx: SxProps = {
  color: 'black'
};

/** @deprecated use IconTooltip from common/ui */
export const Tooltip: React.FC<Props> = ({ children, title, isOpen }) => {
  return (
    <MuiTooltip
      title={
        typeof title === 'string' ? (
          <Typography variant="body2">{title}</Typography>
        ) : (
          title
        )
      }
      {...(isOpen === undefined ? {} : { open: isOpen })}
      placement="top"
      arrow
      componentsProps={{
        tooltip: {
          sx: tooltipSx
        },
        arrow: {
          sx: arrowSx
        }
      }}
    >
      {children}
    </MuiTooltip>
  );
};
